export default __webpack_public_path__ + "static/media/virtualpad_bt_x.476b6adb.png";